module.exports = __webpack_public_path__ + "static/media/right.ebd70523.svg";